/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Template
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface PunctuationOverrides
 */
export interface PunctuationOverrides {
  /**
   * The punctuation marks which the client is prepared to accept in transcription output, or the special value \'all\' (the default). Unsupported marks are ignored. This value is used to guide the transcription process.
   * @type {Array<string>}
   * @memberof PunctuationOverrides
   */
  permitted_marks?: Array<string>;
  /**
   * Ranges between zero and one. Higher values will produce more punctuation. The default is 0.5.
   * @type {number}
   * @memberof PunctuationOverrides
   */
  sensitivity?: number;
}
